import * as React from 'react';

const LeftBoardsLink = ({ onBoardClick, board, totalBoards = 4, ...props }) => {
    const handleGroupClick = (id) => {
        if (onBoardClick) {
            onBoardClick(id);
            console.log(`Clicked: ${id}`);
        }
    };

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={382.604}
            height={117.333}
            viewBox="0 0 101.231 31.044"
            {...props}
        >
            <g transform="translate(-109.216 -100.44)">

                {/* BOARD 4 */}
                {board < 2 && totalBoards > 3 && <g onClick={() => handleGroupClick(4)} style={{ cursor: "pointer" }}>
                    <circle cx={-123.387} cy={132.111} r={1.117} transform="rotate(-90)" style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
                    <circle cx={-123.234} cy={141.051} r={1.117} transform="rotate(-90)" style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
                    <path d="M132.5 123.388c7.269 0 7.269-.255 7.269-.255" style={{ fill: "none", stroke: "#000", strokeWidth: 0.2, strokeDasharray: "1.52992,.764962" }} />

                    <rect
                        width={22.672}
                        height={15.766}
                        x={109.333}
                        y={115.601}
                        rx={3.121}
                        ry={3.121}
                        style={{
                            fill: "transparent", // CHANGED FROM "none"
                            stroke: "#0a5da6",
                            strokeWidth: 0.233788,
                            strokeDasharray: ".935153,.467577",
                        }}
                    />
                    <text
                        xmlSpace="preserve"
                        x={113.496}
                        y={124.917}
                        style={{
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "4px",
                            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                            fill: "none",
                            stroke: "#0a5da6",
                            strokeWidth: 0.4,
                            strokeDasharray: "1.6,.800002",
                            pointerEvents: "none",
                        }}
                    >
                        <tspan x={113} y={124.917} style={{ fontWeight: 700, fill: "#000", stroke: "none" }}>
                            {"Board 4"}
                        </tspan>
                    </text>
                </g>}

                {/* BOARD 3 */}
                {board < 3 && (board + 2) <= totalBoards && <g onClick={() => handleGroupClick(board + 2)} style={{ cursor: "pointer" }}>

                    <circle cx={-123.262} cy={163.68} r={1.117} transform="rotate(-90)" style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
                    <circle cx={-123.109} cy={172.62} r={1.117} transform="rotate(-90)" style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
                    <path d="M164.707 123.262c7.269 0 7.269-.255 7.269-.255" style={{ fill: "none", stroke: "#000", strokeWidth: 0.2, strokeDasharray: "1.52992,.764962" }} />

                    <rect
                        width={22.672}
                        height={15.766}
                        x={141}
                        y={115.475}
                        rx={3.121}
                        ry={3.121}
                        style={{
                            fill: "transparent", // CHANGED FROM "none"
                            stroke: "#0a5da6",
                            strokeWidth: 0.233788,
                            strokeDasharray: ".935153,.467577",
                        }}
                    />
                    <text
                        xmlSpace="preserve"
                        x={148.066}
                        y={124.792}
                        style={{
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "4px",
                            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                            fill: "none",
                            stroke: "#0a5da6",
                            strokeWidth: 0.4,
                            strokeDasharray: "1.6,.800002",
                            pointerEvents: "none",
                        }}
                    >
                        <tspan x={145} y={124.792} style={{ fontWeight: 700, fill: "#000", stroke: "none" }}>
                            {"Board "}{board + 2}
                        </tspan>
                    </text>
                </g>}

                {/* BOARD 2 */}
                {board < 4 && totalBoards !== board && <g onClick={() => handleGroupClick(board + 1)} style={{ cursor: "pointer" }}>
                    <circle cx={186.612} cy={101.557} r={1.117} style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
                    <circle cx={186.612} cy={115.847} r={1.117} style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
                    <path d="M186.612 102.553c0 12.748.226 12.748.226 12.748" style={{ fill: "none", stroke: "#000", strokeWidth: 0.2, strokeDasharray: "1.9107,.955352" }} />

                    <rect
                        width={22.672}
                        height={15.766}
                        x={172.658}
                        y={115.482}
                        rx={3.121}
                        ry={3.121}
                        style={{
                            fill: "transparent", // CHANGED FROM "none"
                            stroke: "#0a5da6",
                            strokeWidth: 0.233788,
                            strokeDasharray: ".935153,.467577",
                        }}
                    />
                    <text
                        xmlSpace="preserve"
                        x={186.821}
                        y={124.799}
                        style={{
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "4px",
                            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                            fill: "none",
                            stroke: "#0a5da6",
                            strokeWidth: 0.4,
                            strokeDasharray: "1.6,.800002",
                            pointerEvents: "none",
                        }}
                    >
                        <tspan x={176.821} y={124.799} style={{ fontWeight: 700, fill: "#000", stroke: "none" }}>
                            {"Board "}{board + 1}
                        </tspan>
                    </text>
                </g>}
            </g>
        </svg >
    );
};

export default LeftBoardsLink;